import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-view-for-selector',
  templateUrl: './view-for-selector.component.html',
  styleUrls: ['./view-for-selector.component.scss']
})
export class ViewForSelectorComponent implements OnInit {
  @Output() dataEvent: EventEmitter<number> = new EventEmitter<number>()
  public static readonly defaultValue = 7
  selectedValue: number
  constructor() {}

  ngOnInit(): void {
    this.selectedValue = ViewForSelectorComponent.defaultValue
  }

  onSelectChange(selectedValue: string) {
    this.dataEvent.emit(Number(selectedValue))
  }
}
